import TextField from "@mui/material/TextField";
import { TextFieldProps } from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import { champ, couleurs, polices } from "../theme/tokens";

/**
 * Champ de formulaire de l'admin.
 *
 * Le socle visuel (pilule blanche, bordure, hauteur, padding, placeholder)
 * vient du thème MUI — `src/theme/index.ts`, components.MuiOutlinedInput.
 * Ce composant n'ajoute que ce qui lui est propre :
 *  - le libellé rendu AU-DESSUS du champ quand la prop `label` est fournie
 *    (le label flottant de MUI n'est pas utilisé dans ce projet) ;
 *  - la marge basse commune entre deux champs.
 */

const labelSx = {
    display: "block",
    fontSize: "13px",
    fontWeight: 700,
    color: couleurs.BleuMarin,
    fontFamily: polices.gras,
    lineHeight: 1.3,
    mb: "15px",
    ml: "4px",
};

/** Masque le label flottant MUI : les libellés sont rendus au-dessus. */
const hideFloatingLabel = {
    "& label.MuiFormLabel-root, & label.MuiInputLabel-outlined": {
        display: "none",
    },
};

export default function LCInputText(props: TextFieldProps) {
    const { label, sx, margin, fullWidth, ...rest } = props;

    const field = (
        <TextField
            {...rest}
            fullWidth={label ? fullWidth ?? true : fullWidth}
            margin={label ? undefined : margin}
            SelectProps={{ displayEmpty: true, ...props.SelectProps }}
            sx={
                label
                    ? hideFloatingLabel
                    : { mb: `${champ.margeBas}px`, ...hideFloatingLabel, ...sx }
            }
        />
    );

    if (!label) {
        return field;
    }

    return (
        <Box sx={{ mb: `${champ.margeBas}px`, ...sx }}>
            <Typography component="label" sx={labelSx}>
                {label}
            </Typography>
            {field}
        </Box>
    );
}
